var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCalendarGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6 2C5.10294 2 4.7 2.40294 4.7 2.9V3.8H3.8C2.80589 3.8 2 4.60589 2 5.6V14.6C2 15.5941 2.80589 16.4 3.8 16.4H14.2C15.1941 16.4 16 15.5941 16 14.6V5.6C16 4.60589 15.1941 3.8 14.2 3.8H13.3V2.9C13.3 2.40294 12.8971 2 12.4 2C11.9029 2 11.5 2.40294 11.5 2.9V3.8H6.5V2.9C6.5 2.40294 6.09706 2 5.6 2ZM5.6 6.5C5.10294 6.5 4.7 6.90294 4.7 7.4C4.7 7.89706 5.10294 8.3 5.6 8.3H12.4C12.8971 8.3 13.3 7.89706 13.3 7.4C13.3 6.90294 12.8971 6.5 12.4 6.5H5.6Z",
    fill: "#DDDDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendarGrey);
export default __webpack_public_path__ + "static/media/Icon_Calendar_Grey.d56e0a8ea23c7a9b2ef69649746bd092.svg";
export { ForwardRef as ReactComponent };